class EditorFieldsDirective
  @$inject: []
  constructor: ()->
    class EditorFields    
      scope:
        source: "="
        schema: "="
      restrict: "E"
      template: require('./index.pug')        
      link: (scope, element, attrs, selector)->
        scope.source ?= {}
        
    return new EditorFields()
module.exports = EditorFieldsDirective


// WEBPACK FOOTER //
// ./src/common/editor/fields/index.coffee